import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../components/Logo';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import api from '../../lib/api';

export default function ForgotPassword() {
  const [sent, setSent] = useState(false);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch {
      // Same message either way — no account enumeration
      setSent(true);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="min-h-screen bg-[#06060a] grid-bg flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="rounded-3xl border border-white/10 bg-[#0B0B0E]/80 backdrop-blur-xl p-8">
          <div className="flex flex-col items-center mb-6"><Logo size="lg" /></div>
          <h1 className="text-3xl font-display font-bold text-white text-center mb-2">Mot de passe oublié</h1>
          <p className="text-sm text-slate-400 text-center mb-7">Saisis ton adresse e-mail : on t’envoie le lien pour choisir un nouveau mot de passe.</p>
          {sent ? (
            <div className="rounded-xl border border-emerald-500/30 bg-emerald-500/10 p-4 text-sm text-emerald-300 text-center">Regarde ta boîte de réception : le lien de récupération vient de partir.</div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-1.5">
                <Label className="text-slate-300">Adresse e-mail</Label>
                <Input type="email" value={email} onChange={e => setEmail(e.target.value)} className="bg-white/5 border-white/10 text-white h-11" required />
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-indigo-500 hover:bg-indigo-600 text-white h-11">{loading ? 'Envoi...' : 'Envoyer le lien'}</Button>
            </form>
          )}
          <div className="text-center text-sm pt-5">
            <Link to="/auth/login" className="text-indigo-400 hover:text-indigo-300">Revenir à la connexion</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
